import React, { use } from 'react';
import '../css/About.css'; 
import {Button, Dialog, DialogTitle, DialogContent ,Zoom, Card, Grid } from '@mui/material';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const About = () => {
  //レスポンシブ対応
  const theme = useTheme();
  const isMobile = theme.breakpoints.down('sm');
  
  const [openAbout, setOpenAbout] = useState(false);
  // モーションcssのカプセル化
  const initialProps = { scaleX: 0, scaleY: 0.001, opacity: 1, backgroundColor: 'gray' };
  const animationProps = [
      {scaleX: 1,backgroundColor: 'gray',transition: { duration: 0.5, ease: 'easeInOut' }},
      {scaleY: 1,opacity: 1,transition: { duration: 0.1, ease: 'easeInOut', delay: 0.5 }}
  ];
  const exitProps = { scaleY: 0, opacity: 1 };
  // cssレイアウト
  const hButtonStyle = {color:"white",fontSize:16,fontWeight:"bold"};
  const dButtonStyle = {width: 80, height:40, backgroundColor: "white", color: "gray", fontSize:16};
  const boxLayout = {boxShadow:10,border:2,borderColor:'white'};
  // 自己紹介
  const intro = "#とりあえず作ってみる";
  const tech = "#学んだこと";
  const profile = "#自己紹介";
  // box表示
  const backEnd = ["java","springboot","larabel","SQL","python","django"];
  const frontEnd = ["typescript","react","material UI","Vanta.js","Three.js","vue.js","vuetify","axios"];
  const other = ["linux","gcp","aws","git","rabbitmq","jmeter","postman","docker","nginx"];
  
  const tableBackArea = (
    <div className='tableArea'>
      <Grid container spacing={2} direction={'row'}>
        {backEnd.map((element) => (
          <Card className='box' sx={boxLayout}><h2>{element}</h2></Card>
        ))}
      </Grid>
    </div>
  );
  const tableFrontArea = (
    <div className='tableArea'>
      <Grid container spacing={2} direction={'row'}>
        {frontEnd.map((element) => (
          <Card className='box' sx={boxLayout}><h2>{element}</h2></Card>
        ))}
      </Grid>
    </div>
  );
  const tableOtherArea = (
    <div className='tableArea'>
      <Grid container spacing={2} direction={'row'}>
        {other.map((element) => (
          <Card className='box' sx={boxLayout}><h2>{element}</h2></Card>
        ))}
      </Grid>
    </div>
  );

  return(
    <div className='body'>
      <Button 
        onClick={() => setOpenAbout(true)}
        style={hButtonStyle}
        >About</Button>
      <Dialog
        fullScreen 
        open = {openAbout}
        onClose = {setOpenAbout}
        disableScrollLock = {true}
        TransitionComponent={Zoom}
        slotProps={{
          paper:{
            style: {
              backgroundColor: "gray",
              transformOrigin: 'center',
              overflow: 'hidden',
            },
            component:motion.div,
            initial:initialProps,
            animate: animationProps,
            exit:exitProps
          }
        }}>
        <Card className='muiCard' sx={{boxShadow:0, background:'gray',overflow:'auto'}}>
        <DialogTitle>
            <h3>About me</h3>
        </DialogTitle>
        <div className='space'/>
        <DialogContent>
          <h4 className='subTitle'>{intro}</h4>
          <p>初めまして、東京出身のエンジニア、サイトウです。
            <br/>このサイトは個人で作成したポートフォリオサイトです。
            <div/>
            <br/>2022年にwebエンジニアとして社内SEで1年働いた後、現在はsesとして現場を渡り歩いてます。
            <div/>
            <br/>新しいものを作るときに、テーマや何が実現できるかなど悩まされることも多いですが、
            <br/>なんだかんだで楽しいです。
          </p>
          <div className='space'/>
          <h4 className='subTitle'>{tech}</h4>
          <div className='space'/>
          <Button className='dButton'
            onClick={() =>  setOpenAbout(false)}
            style={dButtonStyle}>
            close
          </Button>
          <div className='space'/>
          <h4 className='subTitle'>バックエンド</h4>
          <div/>
          {tableBackArea}
          <div/>
          <h4 className='subTitle'>フロントエンド</h4>
          <div/>
          {tableFrontArea}
          <h4 className='subTitle'>その他</h4>
          <div/>
          {tableOtherArea}
        </DialogContent>
            
        </Card>
      </Dialog>
    </div>
  );
}
export default About;